import { Tag }        from 'antd';
import { formatDate } from 'ClientService';
import React          from 'react';
import { useSelector } from 'react-redux';
import { getServerSettings } from 'Redux/Query';

export const Answered = ({ value, record }) => {

  const settings = useSelector(getServerSettings);

  const poolRequestConfirmationOfReceipt = settings?.poolRequestConfirmationOfReceipt || false;

  let now = new Date();
  let answerCompDate = !record.toAnswerDate ? null : new Date(record.toAnswerDate.getFullYear(),
    record.toAnswerDate.getMonth(), record.toAnswerDate.getDate(), 23, 59, 59);

  let tsdCompDate = !record.toSubsequentDeliveryDate ? null : new Date(record.toSubsequentDeliveryDate.getFullYear(),
    record.toSubsequentDeliveryDate.getMonth(), record.toSubsequentDeliveryDate.getDate(), 23, 59, 59);

  if(record.submitDate) {
    return (
      <React.Fragment>
        <Tag color="green">{ poolRequestConfirmationOfReceipt ? 'Bestätigt' : 'Formal korrekt' }: {formatDate(record.submitDate)}</Tag><br />
      </React.Fragment>
    );
  }
  else if(record.answerDate && !record.submitDate) {
    return (
      <React.Fragment>
        <Tag color="magenta">Beantwortet, nicht bestätigt: {formatDate(record.answerDate)}</Tag><br />
      </React.Fragment>
    );
  }
  else if(record.answerDate) {
    return (
      <React.Fragment>
        <Tag color="green">Beantwortet: {formatDate(record.answerDate)}</Tag><br />
      </React.Fragment>
    );
  }
  else if( !record.isCareProviderResponse && ( ( !tsdCompDate && answerCompDate < now ) || ( !!tsdCompDate && tsdCompDate < now ) ) ) {
    let lastDate = record.toSubsequentDeliveryDate ? record.toSubsequentDeliveryDate : record.toAnswerDate;
    return (
      <React.Fragment>
        <Tag color="red">Abgelaufen: {formatDate(lastDate)}</Tag><br />
      </React.Fragment>
    );
  }
  else if( record.answerInbox && ( ( !tsdCompDate && answerCompDate >= now ) || ( !!tsdCompDate && tsdCompDate >= now ) ) ) {
    return (
      <React.Fragment>
        <Tag color="orange">Im LE-Postfach</Tag><br />
      </React.Fragment>
    );
  }
  else if(record.readDate) {
    return (
      <React.Fragment>
        <Tag color={record.isCareProviderResponse ? "green" : "orange"}>Gelesen: {formatDate(record.readDate)} </Tag>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <Tag color="red">Ungelesen</Tag>
    </React.Fragment>
  )
}
